module.exports = __webpack_public_path__ + "img/ico_upload_plus.b6e0e7bf.svg";